import {
  Breakpoint,
  Button,
  ButtonGroup,
  Container,
  Typography,
} from "@mui/material";
import { FormattedMessage } from "react-intl";
import "./PageHeader.scss";
import LockIconOutlined from "@mui/icons-material/LockOutlined";
import { useOidc } from "@axa-fr/react-oidc";
import { LanguageSelect } from "../../Localization";
import Link from "@mui/material/Link";

type PageHeaderProps = {
  title: string;
  maxWidth?: Breakpoint | false;
};

const PageHeader = ({
  title,
  maxWidth
}: PageHeaderProps) => {
  const { isAuthenticated, logout } = useOidc();

  return (
    <Container
      className="page-header"
      maxWidth={false}
      sx={{ bgcolor: "secondary.main", position: "relative" }}
    >
      <Container
        sx={{ position: "absolute", top: 0, left: 0, m: 2, zIndex: 1000 }}
      >
        <Link href={process.env.REACT_APP_PIE_BASE_URL}>
          <img
            src={`${process.env.PUBLIC_URL}/PiELogo.svg`}
            alt="Partners in Energie"
          />
        </Link>
      </Container>
      <Container maxWidth={maxWidth}>
        <Typography variant="h1">
          <FormattedMessage id={title} />
        </Typography>
        <ButtonGroup
          sx={{ position: "absolute", top: 0, right: 0, m: 2, zIndex: 1000 }}
        >
          <LanguageSelect variant="standard" disableUnderline />
          {isAuthenticated && (
            <Button
              className="signout"
              variant="contained"
              size="large"
              onClick={() => logout()}
            >
              <FormattedMessage id="signout"></FormattedMessage>
              <LockIconOutlined sx={{ marginLeft: 0.5 }} />
            </Button>
          )}
        </ButtonGroup>
      </Container>
    </Container>
  );
};

export default PageHeader;
